<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; margin-left: 10px; padding-left: 15px; padding-right: 15px;">
  <div fxFlex="50">
    <div><span (click)="returnBack()" style="cursor: pointer">◀️ Go back</span></div>
  </div>
  <div fxFlex="50" class="text-right">

  </div>
</div>


<mat-card class="content-card">
  <mat-card-header fxLayoutAlign="space-between center">
    <mat-card-title>
      <h5>GPS Load Response File</h5>
    </mat-card-title>
    <div fxFlex></div>

  </mat-card-header>
  <div *appHasRoles="['admin']" fxLayoutGap="10px" style="margin-bottom: 15px;">
    <app-file-upload (upload)="onUpload($event)" [uploadDisabled]="isLoading || isImporting"></app-file-upload>
  </div>

  <mat-progress-bar *ngIf="isImporting" mode="indeterminate"></mat-progress-bar>
  <div *ngIf="csvLines">
    <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
      <label fxFlex="10" class="secondary">Row</label>
      <label fxFlex="16" class="secondary">Token</label>
      <label fxFlex="30" class="secondary">Message</label>
      <label fxFlex="10" class="secondary">Amount</label>


    </div>
    <div>
      <div class="list-item" fxLayout="row" fxLayoutGap="10px" *ngFor="let line of csvLines" [ngStyle]="{ 'color': line.hasError ? 'red' : 'black'}">
        <label class="" fxFlex="10" >{{ line.row }}</label>
        <label class="" fxFlex="16" >{{ line.publicToken }}</label>
        <label class="" fxFlex="30" >{{ line.message }}</label>
        <label class="" fxFlex="10" >{{ line.amount.formatMoneyEuro() }}</label>
      </div>
    </div>
  </div>

</mat-card>

